<template>
  <v-select
    v-model="categoryId"
    :items="page.categories"
    item-text="name"
    item-value="id"
    label="Catégorie forcée"
    :loading="page.loading"
    :no-data-text="
      !forceSiteId
        ? 'Sélectionnez un site'
        : page.loading
        ? 'Chargement…'
        : 'Aucune catégorie trouvée'
    "
    outlined
    :dense="dense"
    hide-details
    clearable
    :disabled="!forceSiteId"
  />
</template>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";

export default {
  name: "ForcedCategoryFilter",
  props: {
    initialValue: {
      default: null,
    },
    forceSiteId: {
      type: Number,
      default: 0,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { axiosGet } = useAxios();

    const page = reactive({
      categories: [],
      categoryId: null,
      loading: false,
    });

    const loadCategories = async () => {
      if (!props.forceSiteId) {
        page.categories = [];
        page.categoryId = null;
        emit("valueChanged", null);
        return;
      }

      page.loading = true;
      try {
        const { data } = await axiosGet("/aif-auto-configs/wp-categories", {
          site_id: props.forceSiteId,
        });
        page.categories = data || [];
      } finally {
        page.loading = false;
      }

      const currentId = Number(page.categoryId || 0);
      const exists = page.categories.some(
        (item) => Number(item.id) === currentId
      );
      if (!exists) {
        page.categoryId = null;
        emit("valueChanged", null);
      }
    };

    const categoryId = computed({
      get: () => page.categoryId,
      set: (value) => {
        const normalized = Number(value || 0) || null;
        page.categoryId = normalized;
        emit("valueChanged", normalized);
      },
    });

    watch(
      () => props.initialValue,
      (value) => {
        page.categoryId = Number(value || 0) || null;
      },
      { immediate: true }
    );

    watch(
      () => props.forceSiteId,
      async () => {
        await loadCategories();
      }
    );

    onMounted(async () => {
      await loadCategories();
    });

    return {
      categoryId,
      page,
    };
  },
};
</script>
